import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Image, UL, LI } from "../../../../AbstractElements";
import { useSelector } from "react-redux";
import {
  FaInfoCircle,
  FaSearch,
  FaTrash,
  FaUser,
  FaUserPlus,
  FaPencilAlt,
} from "react-icons/fa";
import { GoPencil } from "react-icons/go";

import { MdDelete } from "react-icons/md";
import {
  Button,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  InputGroupText,
} from "reactstrap";
import Swal from "sweetalert2";
import { setChatLoading, setChatMessages } from "../../../../utils/chatSlice";
import { useDispatch } from "react-redux";
import {
  selectUser,
  setIsGroup,
  setSearchUser,
  setUsers,
} from "../../../../utils/userSlice";
import dropdown_click_icon from "../../../../../src/assets/images/dropdown_click_icon.png";
import cancel_icon from "../../../../../src/assets/images/cancel_icon.png";
import search_chat_icon from "../../../../../src/assets/images/search_chat_icon.png";
import { isMobile } from "react-device-detect";
import ChatAppContext from "../../../../_helper/Chat";
import { useForm } from "react-hook-form";

const ChatHeader = () => {
  // const { memberss, currentUserr, chatss, changeChat, createNewChatAsyn } =
  //   useContext(ChatAppContext);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
    setError,
    clearErrors,
  } = useForm();

  const baseurl = useSelector((store) => store.baseUrl);
  const selectedUserr = useSelector((state) => state?.users?.selectedUser);
  const chatMessages = useSelector((state) => state?.chats?.chatmessages);
  const users = useSelector((state) => state.users.users);
  const dispatch = useDispatch();

  const [groupInfo, setGroupInfo] = useState(null); // For group details
  const [groupMembers, setGroupMembers] = useState([]); // For group members
  // const [filteredGroupMembers, setFilteredGroupMembers] = useState([]);
  const [groupinfomodal, setGroupinfomodal] = useState(false);
  const [addmembermodal, setAddmembermodal] = useState(false);
  const isgroup = useSelector((state) => state?.users?.isGroup);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  // Function to filter members based on search query
  // Optimized input change handler using useCallback
  const handleSearchGroupMember = useCallback((e) => {
    setSearchQuery(e.target.value);
  }, []);

  // Toggle function for modal
  const toggleGroupinfo = () => {
    setGroupinfomodal(!groupinfomodal);
    setGroupMembers([]);
    setSearchQuery("");
  };

  const [isEditingName, setIsEditingName] = useState(false);
  const [groupName, setGroupName] = useState(groupInfo?.group_name || "");
  const [isHovered, setIsHovered] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // const [isUploading, setIsUploading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const fileInputRef = useRef(null);

  // Open file input on click
  const handleEditImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      alert("Invalid file type. Please select a JPG, JPEG, or PNG image.");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      alert("File size exceeds 2MB. Please select a smaller image.");
      return;
    }

    setSelectedFile(file);
    // setIsUploading(true);

    await groupInfoChange(file, false); // Do not send group_name

    // setIsUploading(false);
  };

  const handleSaveName = async () => {
    if (!groupName.trim()) return;

    setIsSaving(true);
    await groupInfoChange();
    setIsSaving(false);
  };

  const handleCancelEdit = () => {
    setGroupName(groupInfo?.group_name || "");
    setIsEditingName(false);
  };

  const groupInfoChange = async (file, includeGroupName = true) => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("group_id", selectedUserr?.group_id);
    if (includeGroupName && groupName) {
      formData.append("group_name", groupName);
    }
    if (file) {
      formData.append("photo_path", file);
    }

    try {
      const response = await fetch(`${baseurl}/common_api/saveGroupRename/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      const { STATUS, MSG } = result[0] || {};

      if (STATUS == "SUCCESS") {
        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Group Updated",
          text: MSG || "Group name or photo updated successfully.",
          timer: 3000,
          showConfirmButton: true,
        });
        setIsEditingName(false);
        // await handleInfoClick(selectedUserr);
        // await fetchEmployeeList(selectedUserr);
        await Promise.all([
          handleInfoClick(selectedUserr),
          fetchEmployeeList(selectedUserr),
        ]);
      } else {
        // Show error modal using SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: MSG || "Failed to create group. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);

      // Show unexpected error modal
      // Swal.fire({
      //   icon: "error",
      //   title: "Unexpected Error",
      //   text:
      //     error.message || "An unexpected error occurred. Please try again.",
      // });
    }
  };

  // Memoized filtered members for performance
  // const filteredGroupMembers = useMemo(() => {
  //   return groupMembers.filter((member) =>
  //     member?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // }, [searchQuery, groupMembers]);

  const filteredGroupMembers = useMemo(() => {
    const normalizedQuery = searchQuery.replace(/\s+/g, "").toLowerCase(); // Remove spaces & lowercase

    return groupMembers.filter((member) => {
      const normalizedName = member?.name?.replace(/\s+/g, "").toLowerCase(); // Normalize name
      return normalizedName.includes(normalizedQuery);
    });
  }, [searchQuery, groupMembers]);

  const toggleAddMember = () => setAddmembermodal(!addmembermodal);

  //state for select employees
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [Users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  // const [group_name, setGroupName] = useState("");
  // // const [searchUser, setSearchUser] = useState("");
  // const handleSearchUser = (keyword) => {
  //   // setSearchUser(keyword);
  // };
  // const users = useSelector((state) => state.users.users);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const isGroupCreator = userdetails?.employee_id == selectedUserr?.created_by;

  const handleCheckboxChange = (id) => {
    if (id == "selectAll") {
      if (selectedEmployees.length == filteredUsers.length) {
        setSelectedEmployees([]); // Deselect all
      } else {
        setSelectedEmployees(filteredUsers.map((emp) => emp.employee_id)); // Select all
      }
    } else {
      setSelectedEmployees(
        (prev) =>
          prev.includes(id)
            ? prev.filter((empId) => empId != id) // Deselect the employee
            : [...prev, id] // Select the employee
      );
    }
  };

  // Filtered users based on search text and excluding the current user
  // const filteredUsers = users.filter(
  //   (x) =>
  //     x?.employee_id != userdetails?.employee_id &&
  //     x?.name?.toLowerCase().includes(searchText.toLowerCase()) // Search filter logic
  // );

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = Users.filter((user) =>
      user?.name?.toLowerCase().includes(value)
    );

    setFilteredUsers(filtered);
  };

  // Function to handle the Info icon click
  const handleInfoClick = async (selectedUser) => {
    if (!selectedUser) return; // Exit if no user is selected
    toggleGroupinfo(); // Open modal

    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("groupid", selectedUser?.group_id);

      const response = await fetch(`${baseurl}/common_api/group_info/`, {
        method: "POST",
        body: formData,
      });
      const res = await response.json();

      if (res[0].STATUS == "SUCCESS") {
        setGroupInfo(res[0].DATA[0].group_detail[0]);
        // Only store members who are "In Group"
        setGroupMembers(
          res[0].DATA[0].group_member.filter(
            (member) => member?.Status == "In Group"
          )
        );
      } else {
        setGroupInfo(null);
        setGroupMembers([]);
      }
    } catch (error) {
      setGroupInfo(null);
      setGroupMembers([]);
    }
  };

  // Function to handle the add icon click
  const getMembersListInGroup = async (selectedUser) => {
    if (!selectedUser) return; // Exit if no user is selected
    toggleAddMember(); // Open modal

    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("group_id", selectedUser?.group_id);

      const response = await fetch(
        `${baseurl}/common_api/getMembersListInGroup/`,
        {
          method: "POST",
          body: formData,
        }
      );
      const res = await response.json();

      if (res[0].STATUS == "SUCCESS") {
        setUsers(res[0]?.DATA);
        setFilteredUsers(res[0]?.DATA);
      } else {
        setUsers([]);
        setFilteredUsers([]);
      }
    } catch (error) {
      console.error(error?.message);
      setUsers([]);
      setFilteredUsers([]);
    }
  };

  const fetchEmployeeList = async (selectedUser) => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("user_id", userdetails?.employee_id);
    formData.append("get_group", "Y");
    formData.append("user_type", userdetails?.user_type);

    try {
      const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (result[0]?.STATUS == "SUCCESS") {
        const employeeArr = result[0]?.DATA?.employee_arr;
        const matchedUser = employeeArr.find(
          (emp) => emp.group_id == selectedUser?.group_id
        );

        if (matchedUser) {
          dispatch(selectUser(matchedUser));
        }
        dispatch(setUsers(employeeArr));
      } else {
        console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
        dispatch(setUsers([]));
      }
    } catch (error) {
      console.error("Error fetching employee list:", error.message);
      dispatch(setUsers([]));
    }
  };

  // Function to handle the add delete click
  const handleDeleteClick = async (selectedUserr) => {
    if (!selectedUserr) return; // Exit if no user is selected

    // Show confirmation dialog using SweetAlert2
    const result = await Swal.fire({
      title: isgroup
        ? isGroupCreator
          ? `Exit and Delete "${selectedUserr?.name}" Group?`
          : `Exit "${selectedUserr?.name}" Group?`
        : `Clear Chat with "${selectedUserr?.name}"?`,
      text: isgroup
        ? isGroupCreator
          ? `Are you sure you want to exit and delete "${selectedUserr?.name}" Group? This action cannot be undone.`
          : `Are you sure you want to exit "${selectedUserr?.name}" Group?`
        : `Are you sure you want to clear your chat with "${selectedUserr?.name}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: isgroup
        ? isGroupCreator
          ? `Yes, Exit and Delete Group`
          : `Yes, Exit Group`
        : `Yes, Clear Chat `,
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const formData = new FormData();
        formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
        formData.append("PHPTOKEN", localStorage.getItem("id_token"));

        if (isgroup) {
          formData.append("groupid", selectedUserr?.group_id);
          formData.append("memberid", selectedUserr?.member_id);
        } else {
          formData.append("receiver_id", selectedUserr?.employee_id);
          formData.append("receiver_type", selectedUserr?.user_type);
          const { employee_id: senderId, user_type: senderType } = userdetails;
          formData.append("sender_id", senderId);
          formData.append("sender_type", senderType);
        }

        const apiEndpoint = isgroup
          ? `${baseurl}/common_api/groupdeletechat/`
          : `${baseurl}/common_api/deletechat/`;

        const response = await fetch(apiEndpoint, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        const { STATUS, MSG } = result[0] || {};

        if (STATUS == "SUCCESS") {
          Swal.fire(
            "Deleted!",
            isgroup ? "Group has been deleted." : "Chat has been deleted.",
            "success"
          );

          if (isgroup) {
            // await fetchEmployeeList();
            // await fetchChatHistory(selectedUserr, userdetails);
            dispatch(setIsGroup(false)); // Default to false in case of failure
            dispatch(setChatMessages([])); // Clear previous messages
            dispatch(selectUser(users[0]));
            dispatch(setSearchUser(""));
          } else {
            dispatch(setChatMessages([])); // Clear previous messages
          }
        } else {
          Swal.fire("Error!", MSG || "Failed to delete.", "error");
          console.error("Failed to delete:", STATUS);
        }
      } catch (error) {
        Swal.fire("Error!", error.message, "error");
        console.error("Error deleting:", error);
      }
    } else {
      // console.log("Deletion cancelled by user.");
    }
  };

  // Function to handle the add icon click
  const addMembersInGroup = async (selectedUser) => {
    if (!selectedUser) return; // Exit if no user is selected
    toggleAddMember(); // Open modal

    try {
      const formData = new FormData();
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));
      formData.append("group_id", selectedUser?.group_id);
      formData.append("person_type", userdetails?.user_type);

      // Append selectedEmployees as person_id[]
      selectedEmployees.forEach((id) => {
        formData.append("person_id[]", id);
      });

      const response = await fetch(`${baseurl}/common_api/addMembersInGroup/`, {
        method: "POST",
        body: formData,
      });
      const res = await response.json();

      if (res[0].STATUS === "SUCCESS") {
        setUsers(res[0]?.DATA);
        setFilteredUsers(res[0]?.DATA);
        setSelectedEmployees([]);
        toggleAddMember();
        setSearchText("");

        // Show success alert
        Swal.fire({
          title: "Success!",
          text: "Members have been added successfully.",
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      } else {
        setUsers([]);
        setFilteredUsers([]);

        // Show error alert
        Swal.fire({
          title: "Error!",
          text: "Failed to add members. Please try again.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error(error?.message);
      setUsers([]);
      setFilteredUsers([]);

      // Show error alert
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };

  // Function to handle the add icon click
  const deleteMembersInGroup = async (selectedUser, person_id) => {
    if (!selectedUser) return; // Exit if no user is selected

    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This member will be removed from the group!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26994e",
      cancelButtonColor: "#FE0606 ",
      confirmButtonText: "Yes, delete it!",
    });

    // If user confirms deletion
    if (result.isConfirmed) {
      try {
        const formData = new FormData();
        formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
        formData.append("PHPTOKEN", localStorage.getItem("id_token"));
        formData.append("group_id", selectedUser?.group_id);
        formData.append("person_id", person_id);

        const response = await fetch(
          `${baseurl}/common_api/deleteMembersInGroup/`,
          {
            method: "POST",
            body: formData,
          }
        );
        const res = await response.json();

        if (res[0].STATUS === "SUCCESS") {
          Swal.fire("Deleted!", "Member has been removed.", "success");
          toggleGroupinfo();
          // getMembersListInGroup(selectedUser); // Uncomment if needed
        } else {
          Swal.fire("Error!", "Something went wrong. Try again.", "error");
        }
      } catch (error) {
        console.error(error?.message);
        Swal.fire("Error!", "Failed to delete the member.", "error");
      }
    }
  };

  // Centralized Fetch Function
  // const fetchChatHistory = async (selectedUserr, userdetails) => {
  //   if (!selectedUserr) return; // Exit if no user is selected

  //   // dispatch(setChatMessages([])); // Clear previous messages
  //   // dispatch(setChatLoading({ isLoading: true })); // Show loading indicator

  //   try {
  //     let apiEndpoint = "";
  //     const formData = new FormData();

  //     // Append common fields
  //     formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
  //     formData.append("PHPTOKEN", localStorage.getItem("id_token"));

  //     // Determine API endpoint and specific fields
  //     if (isgroup) {
  //       // Group chat case
  //       apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
  //       formData.append("groupid", selectedUserr?.group_id);
  //       formData.append("memberid", selectedUserr?.member_id);
  //     } else {
  //       // Individual chat case
  //       apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
  //       formData.append("receiver_id", selectedUserr.employee_id);
  //       formData.append("receiver_type", selectedUserr.user_type);
  //       const { employee_id: senderId, user_type: senderType } = userdetails;
  //       formData.append("sender_id", senderId);
  //       formData.append("sender_type", senderType);
  //     }

  //     // Fetch data from the API
  //     const response = await fetch(apiEndpoint, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const result = await response.json();
  //     const { STATUS, DATA } = result[0] || {};

  //     if (STATUS == "SUCCESS") {
  //       // Sort and dispatch messages
  //       // const sortedMessages = DATA?.sort((a, b) => a.order_no - b.order_no);
  //       dispatch(setChatMessages(DATA));
  //     } else {
  //       console.error("Failed to fetch chat history:", STATUS);
  //       dispatch(setChatMessages([]));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching chat history:", error.message);
  //     dispatch(setChatMessages([]));
  //   } finally {
  //     dispatch(setChatLoading({ isLoading: false })); // Reset loading indicator
  //   }
  // };

  // Function to fetch employee list
  // const fetchEmployeeList = async () => {
  //   const formData = new FormData();
  //   formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
  //   formData.append("PHPTOKEN", localStorage.getItem("id_token"));
  //   formData.append("user_id", userdetails?.employee_id);
  //   formData.append("get_group", "Y");
  //   formData.append("user_type", userdetails?.user_type);

  //   try {
  //     const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
  //       method: "POST",
  //       body: formData,
  //     });
  //     console.log(response, "response...fetchEmployeeList");
  //     const result = await response.json();
  //     console.log(result, "result...fetchEmployeeList");

  //     if (result[0]?.STATUS === "SUCCESS") {
  //       const employeeArr = result[0]?.DATA?.employee_arr;
  //       dispatch(setUsers(employeeArr));
  //       dispatch(selectUser(employeeArr[0]));
  //     } else {
  //       console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
  //       dispatch(setUsers([]));
  //       dispatch(selectUser({}));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching employee list:", error.message);
  //     dispatch(setUsers([]));
  //     dispatch(selectUser({}));
  //   }
  // };

  // const fetchEmployeeList = async () => {
  //   const formData = new FormData();
  //   formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
  //   formData.append("PHPTOKEN", localStorage.getItem("id_token"));
  //   formData.append("user_id", userdetails?.employee_id);
  //   formData.append("get_group", "Y");
  //   formData.append("user_type", userdetails?.user_type);

  //   try {
  //     const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
  //       method: "POST",
  //       body: formData,
  //     });
  //     console.log(response, "response...fetchEmployeeList");
  //     const result = await response.json();
  //     console.log(result, "result...fetchEmployeeList");

  //     if (result[0]?.STATUS === "SUCCESS") {
  //       const employeeArr = result[0]?.DATA?.employee_arr;

  //       if (employeeArr && employeeArr.length > 0) {
  //         dispatch(setUsers(employeeArr));
  //         dispatch(selectUser(employeeArr[0]));

  //         // Check if it is a group or individual user
  //         if (employeeArr[0]?.group_id) {
  //           dispatch(setIsGroup(true)); // It's a group
  //         } else if (employeeArr[0]?.employee_id) {
  //           dispatch(setIsGroup(false)); // It's an individual user
  //         }
  //       } else {
  //         dispatch(setUsers([]));
  //         dispatch(selectUser({}));
  //         dispatch(setIsGroup(false)); // Default to false if no users found
  //       }
  //     } else {
  //       console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
  //       dispatch(setUsers([]));
  //       dispatch(selectUser({}));
  //       dispatch(setIsGroup(false)); // Default to false in case of failure
  //     }
  //   } catch (error) {
  //     console.error("Error fetching employee list:", error.message);
  //     dispatch(setUsers([]));
  //     dispatch(selectUser({}));
  //     dispatch(setIsGroup(false)); // Default to false in case of an error
  //   }
  // };

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleHeaderDropdown = (event) => {
    event.stopPropagation(); // Prevent immediate closing
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      setTimeout(() => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      }, 0); // Delay execution so state updates first
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Fragment>
      <div className="chat-header clearfix">
        <Image
          attrImage={{
            className: "rounded-circle right-side-user-header",
            src: `${selectedUserr?.photo_path || selectedUserr?.groupphoto}`,
            alt: "",
          }}
        />
        <div className="media-body">
          <div className="about">
            <div className="name">
              {selectedUserr ? selectedUserr?.name : "Vincent Porter"}
            </div>
          </div>
        </div>
        <UL
          attrUL={{
            className:
              "simple-list list-inline float-start float-sm-end chat-menu-icons d-flex flex-row",
          }}
        >
          {/* {isgroup && (
            <LI attrLI={{ className: "list-inline-item border-0" }}>
              <FaInfoCircle
                size={24}
                color="#fbb03b"
                onClick={() => handleInfoClick(selectedUserr)} // Handle info icon click
                style={{ cursor: "pointer" }}
              />
            </LI>
          )}

          {selectedUserr?.created_by == userdetails?.employee_id && isgroup && (
            <LI attrLI={{ className: "list-inline-item border-0" }}>
              <FaUserPlus
                size={24}
                color="#26994e"
                onClick={() => getMembersListInGroup(selectedUserr)} // Handle add member click
                style={{ cursor: "pointer" }}
              />
            </LI>
          )}

          {selectedUserr && (isgroup || chatMessages?.length > 0) && (
            <LI attrLI={{ className: "list-inline-item border-0" }}>
              <MdDelete
                size={24}
                color="#FE0606"
                onClick={() => handleDeleteClick(selectedUserr)} // Handle delete icon click
                style={{ cursor: "pointer" }}
              />
            </LI>
          )} */}

          {/* <LI attrLI={{ className: "list-inline-item border-0 me-4" }}>
            <Image
              attrImage={{
                src: `${search_chat_icon}`,
                className: "img-fluid dropdown-click-img",
                alt: "",
              }}
            />
          </LI> */}

          {selectedUserr && (isgroup || chatMessages?.length > 0) && (
            <LI
              attrLI={{
                className: "list-inline-item border-0",
                onClick: toggleHeaderDropdown,
              }}
            >
              <Image
                attrImage={{
                  src: `${dropdown_click_icon}`,
                  className: "img-fluid dropdown-click-img ",
                  alt: "",
                  style: { cursor: "pointer" },
                  // onClick: toggleHeaderDropdown,
                }}
              />
            </LI>
          )}
        </UL>

        {/* Dropdown Content */}
        {isOpen && (
          <div
            className={`dropdown-content ${isOpen ? "open" : "closed"}`}
            ref={dropdownRef}
          >
            {selectedUserr?.created_by == userdetails?.employee_id &&
              isgroup && (
                <LI
                  attrLI={{
                    className: "list-inline-item border-0 text-center p-3",
                    onClick: () => getMembersListInGroup(selectedUserr),
                  }}
                >
                  Add Member
                </LI>
              )}
            {isgroup && (
              <LI
                attrLI={{
                  className: "list-inline-item border-0 text-center p-3",
                  onClick: () => handleInfoClick(selectedUserr),
                }}
              >
                Group Info
              </LI>
            )}
            {selectedUserr && (isgroup || chatMessages?.length > 0) && (
              <LI
                attrLI={{
                  className: "list-inline-item border-0 text-center p-3",
                  onClick: () => handleDeleteClick(selectedUserr),
                }}
              >
                {isgroup
                  ? isGroupCreator
                    ? "Exit and Delete Group"
                    : "Exit Group"
                  : "Clear Chat"}
              </LI>
            )}
          </div>
        )}
      </div>

      {/* className={`dropdown-content ${isOpen ? "open" : "closed"}`} */}

      {/* Modal group info start*/}
      <Modal isOpen={groupinfomodal} toggle={toggleGroupinfo} centered>
        <ModalHeader
          toggle={toggleGroupinfo}
          style={{ backgroundColor: "#198754", color: "#fff" }}
          className="group-info-header"
        >
          Group Info
        </ModalHeader>
        <ModalBody>
          {/* Group Details */}
          {/* Group Details */}
          {groupInfo && (
            <div className="group-info-container">
              {/* Image Section */}
              <div
                className={`group-image-wrapper ${isHovered ? "hovered" : ""}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                // onClick={handleEditImageClick}
              >
                <img
                  src={groupInfo?.group_image}
                  alt="Group"
                  className="group-image"
                />
                {/* {isHovered && <GoPencil className="image-edit-icon" />} */}
                {/* <input
                  type="file"
                  accept="image/jpeg, image/jpg, image/png"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleImageUpload}
                /> */}
              </div>

              {/* Group Details Section */}
              <div className="group-details">
                {isEditingName ? (
                  <div className="group-name-edit user-chat-search d-flex justify-content-center align-items-center">
                    <input
                      type="text"
                      value={groupName}
                      onChange={(e) => setGroupName(e.target.value)}
                      className="group-name-input"
                    />
                    <Button
                      onClick={handleSaveName}
                      className="save-groupname-btn ms-2"
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : "Save"}
                    </Button>
                    <img
                      src={cancel_icon}
                      alt="cancel-icon"
                      onClick={handleCancelEdit}
                      style={{ cursor: "pointer" }}
                      className="ms-2"
                    />
                  </div>
                ) : (
                  <h5 className="group-name m-0">
                    {groupInfo?.group_name}
                    <GoPencil
                      className="name-edit-icon"
                      onClick={() => {
                        setIsEditingName(true);
                        setGroupName(groupInfo?.group_name || "");
                      }}
                    />
                  </h5>
                )}
                <p className="m-0">
                  <b>Created by:</b> {groupInfo?.group_creater}
                </p>
                <p className="m-0">
                  <b>Created on:</b> {groupInfo?.group_created_dt}
                </p>
                <p className="m-0">
                  <b>Members:</b> {groupMembers?.length}
                </p>
              </div>
            </div>
          )}

          {/* Search Bar */}
          <FormGroup className="form-group user-chat-search search-group-member-input">
            <Input
              className="form-control"
              type="text"
              placeholder="Search Members"
              value={searchQuery}
              onChange={handleSearchGroupMember}
            />
            <i className="fa fa-search"></i>
            {/* <img src={search_icon} alt="Search" className="search-img" /> */}
          </FormGroup>

          {/* Members Table */}
          <div
            style={{
              maxHeight: "300px", // Adjust the height threshold for scrolling
              overflowY: "auto", // Enable vertical scrollbar
              border: "1px solid #dee2e6", // Optional: add border for clarity
            }}
          >
            <Table bordered responsive striped>
              <thead>
                <tr style={{ backgroundColor: "#f8f9fa" }}>
                  <th>Sr. No.</th>
                  <th>Person Name</th>
                  <th>Status</th>
                  {selectedUserr?.created_by == userdetails?.employee_id &&
                    isgroup && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {filteredGroupMembers.length > 0 ? (
                  filteredGroupMembers.map((member, index) => (
                    <tr key={member?.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        {member?.name}
                        {member?.person_id == selectedUserr?.created_by && (
                          <span className="fw-bold"> (Group Admin)</span>
                        )}
                      </td>
                      <td>{member?.Status}</td>
                      <td className="text-center">
                        {/* Show delete icon only if logged-in user is the group creator AND the member is not the Group Admin */}
                        {userdetails?.employee_id ==
                          selectedUserr?.created_by &&
                          member?.person_id != selectedUserr?.created_by && (
                            <FaTrash
                              onClick={() =>
                                deleteMembersInGroup(
                                  selectedUserr,
                                  member?.person_id
                                )
                              }
                              style={{ cursor: "pointer", color: "red" }}
                            />
                          )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No results found for "{searchQuery}"
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>
      {/* Modal group info end*/}

      {/* Modal add memeber start*/}
      <Modal
        className="create-group-modal"
        isOpen={addmembermodal}
        toggle={toggleAddMember}
        centered
      >
        <ModalHeader
          toggle={() => {
            toggleAddMember();
            setSearchText("");
            setSelectedEmployees([]);
            reset();
          }}
          style={{ backgroundColor: "#198754", color: "#fff" }}
          className="group-info-header"
        >
          Add Member
        </ModalHeader>

        <ModalBody>
          <Row className="mt-4">
            <Col sm="12" xl="12">
              <Form className="theme-form custom-form">
                <FormGroup
                  className={`row formdiv-margin ${
                    isMobile ? "" : "mb-2"
                  } custom-form-group`}
                >
                  <Label
                    className={`col-sm-4 col-form-label timesheet-label ${
                      isMobile ? "text-start" : "text-end"
                    } custom-label`}
                    htmlFor="selectEmployeeDropdown"
                  >
                    Select Employee:
                  </Label>
                  <Col sm="8">
                    <Dropdown
                      isOpen={dropdownOpen}
                      toggle={toggleDropdown}
                      className="w-100 custom-dropdown"
                    >
                      <DropdownToggle
                        caret
                        className="form-control register-full input-register select-font text-start employee-dropdown custom-dropdown-toggle"
                      >
                        {selectedEmployees.length > 0
                          ? `${selectedEmployees.length} selected`
                          : "Select Employee"}
                      </DropdownToggle>
                      <DropdownMenu className="w-100 p-2 custom-dropdown-menu">
                        <div className="mb-2">
                          <Input
                            type="text"
                            placeholder="Search"
                            value={searchText}
                            onChange={handleSearch}
                            className="form-control search-employee custom-search-input"
                          />
                        </div>
                        {filteredUsers.length > 0 && (
                          <div className="form-check select-emp-dropdownlist custom-select-all">
                            <input
                              type="checkbox"
                              id="selectAll"
                              className="form-check-input employee-selectall-checkbox custom-checkbox"
                              checked={
                                selectedEmployees.length == filteredUsers.length
                              }
                              onChange={() => handleCheckboxChange("selectAll")}
                            />
                            <label
                              htmlFor="selectAll"
                              className="form-check-label custom-checkbox-label"
                            >
                              Select All
                            </label>
                          </div>
                        )}

                        {filteredUsers.length > 0 ? (
                          filteredUsers.map((user) => (
                            <div
                              key={user?.employee_id}
                              className="form-check select-emp-dropdownlist custom-dropdown-item"
                            >
                              <input
                                type="checkbox"
                                id={user?.employee_id}
                                className="form-check-input employee-checkbox custom-checkbox"
                                checked={selectedEmployees.includes(
                                  user?.employee_id
                                )}
                                onChange={() =>
                                  handleCheckboxChange(user?.employee_id)
                                }
                              />
                              <label
                                htmlFor={user?.employee_id}
                                className="form-check-label custom-checkbox-label"
                              >
                                {user?.name}
                              </label>
                            </div>
                          ))
                        ) : (
                          <div>
                            <p className="text-center">
                              No results found for{" "}
                              <strong>'{searchText}'</strong>
                            </p>
                          </div>
                        )}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter className="custom-modal-footer">
          <Button
            color="primary"
            className="custom-save-btn"
            type="button"
            onClick={() => addMembersInGroup(selectedUserr)}
          >
            Save
          </Button>
          <Button
            color="secondary"
            className="custom-cancel-btn"
            onClick={() => {
              toggleAddMember();
              setSearchText("");
              setSelectedEmployees([]);
              reset();
              // clearErrors("selectedEmployees"); // Clear error when modal is canceled
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      {/* Modal add memeber end*/}
    </Fragment>
  );
};
export default ChatHeader;
